import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { Paper, Grid, Box, Dialog, DialogContent, Typography, Divider, FormControlLabel, Checkbox, Chip, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { LocalAtm, Description, Warning, CalendarToday, Info, CheckCircle } from '@material-ui/icons';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';

import { loadTermsOfUseUsers, confirmTermsOfUse } from '../../store/thunk';
import { setTermsOfUseDate } from 'pages/Login/store/actions';

const NfsePremiumIcon = require('../../../../assets/img/nfse-premium-icon.png');

export default function TermsOfUseModal({ isDismissable = false, isTermsAccepted = false, isOpen, setIsOpen }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { isAdminUser } = useSelector(state => state.profile.submit);
  const { isTermsOfUseLoading, termsOfUseUsers } = useSelector(state => state.provisionalReceiptConfig);

  const isUserAdmin = +isAdminUser == 1;

  const sortedUniqueTermsOfUseUsers = (termsOfUseUsers || [])
    .slice()
    .sort((firstUser, secondUser) => moment(firstUser?.acceptanceDateTime, 'YYYY-MM-DD HH:mm:ss').valueOf() - moment(secondUser?.acceptanceDateTime, 'YYYY-MM-DD HH:mm:ss').valueOf())
    .filter((user, index, users) => index == users.findIndex(currentUser => currentUser?.name == user?.name));

  const [isNfTermsChecked, setIsNfTermsChecked] = useState(false);

  useEffect(() => {
    if(isTermsAccepted && isUserAdmin) {
      dispatch(loadTermsOfUseUsers(userId, establishmentId));
    }
  }, [isTermsAccepted, isUserAdmin]);

  const handleConfirmTermsOfUse = () => {
    return dispatch(confirmTermsOfUse(userId, establishmentId))
      .then(() => {
        dispatch(setTermsOfUseDate(moment(moment.now())));
        setIsOpen(false);
      });
  }

  const StepCard = ({ icon, title, children }) => (
    <Box
      style={{
        padding: 20,
        borderRadius: 20,
        border: '1px solid #D7E3F4',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)'
      }}
    >
      <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 5 }}>
        <Box style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {icon}
          <Typography variant='body1' color='primary'>
            <b>{title}</b>
          </Typography>
        </Box>
      </Box>
      {children}
    </Box>
  );

  return(
    <Dialog
      fullWidth
      maxWidth="md"
      open={isOpen}
      onClose={() => {
        if(isDismissable) {
          setIsOpen(false);
        }
      }}
      PaperProps={{
        style: {
          position: 'relative',
          borderRadius: 24,
          overflow: 'hidden',
          background: '#F8FAFC'
        }
      }}
    >
      <Loader isLoading={isTermsOfUseLoading}>
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20, backgroundColor: '#022A5C' }}>
          <Typography variant='h6' style={{ color: '#FFFFFF' }}>
            Emissão de Notas Fiscais
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            Termo Específico · Versão 2.0
          </Typography>
        </Box>
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20, backgroundColor: '#FFFFFF' }}>
          <Typography variant='h6' style={{ color: '#FFFFFF' }}>
            <Chip
              label='Vigência a partir de 1º de agosto de 2026'
              style={{ backgroundColor: '#FCF4CC', color: '#88451D', border: '1px solid #EBAA45' }}
            />
          </Typography>
          <Typography variant='body2' color='textSecondary' style={{ marginTop: 5 }}>
            Publicado em junho de 2026 · Jump Tecnologia de Informação LTDA
          </Typography>
        </Box>
        <DialogContent style={{ padding: 30, backgroundColor: '#F5F5F5' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <StepCard
                icon={<LocalAtm color='primary' />}
                title='1. Objeto'
              >
                <Typography variant='body2' color='primary'>
                  O presente Termo regula as condições de uso da funcionalidade de emissão de Notas Fiscais Eletrônicas (NFS-e, NFC-e e NF-e) disponibilizada pela Jump Tecnologia de Informação LTDA por meio de suas plataformas Jump Park e Jump Car, a partir de 1º de agosto de 2026.
                </Typography>
              </StepCard>
            </Grid>
            <Grid item xs={12}>
              <StepCard
                icon={<Description color='primary' />}
                title='2. Planos de Emissão e Valores'
              >
                <Typography variant='body2' color='primary'>
                  A cobrança é apurada mensalmente com base na quantidade total de notas fiscais emitidas no período. O enquadramento ocorre automaticamente conforme o volume apurado — não há escolha prévia ou contratação de faixa específica. Cada faixa possui um valor máximo mensal e uma tarifa progressiva por nota excedente ao limite inferior da faixa.
                </Typography>
                <TableContainer component={Paper} style={{ marginTop: 20, marginBottom: 20, borderRadius: 15 }}>
                  <Table>
                    <TableHead style={{ backgroundColor: '#0D1F3C' }}>
                      <TableCell>
                        <Typography style={{ color: '#FFFFFF' }}>
                          <b>Faixa de Notas</b>
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ color: '#FFFFFF' }}>
                          <b>Valor Máximo Mensal</b>
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ color: '#FFFFFF' }}>
                          <b>Excedente por Nota</b>
                        </Typography>
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ backgroundColor: '#ECFDF5' }}>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            0 a 500 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#2DBE60' }}>
                            <b>Gratuito</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,98 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            501 a 1.000 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            <b>R$ 49,00</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,80 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            1.001 a 2.000 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            <b>R$ 89,00</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,80 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            2.001 a 3.000 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            <b>R$ 129,00</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,60 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            3.001 a 4.000 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            <b>R$ 189,00</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,40 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            4.001 a 5.000 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            <b>R$ 229,00</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,40 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            5.001 a 6.000 notas
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' color='primary'>
                            <b>R$ 269,00</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,40 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ backgroundColor: '#FCF4CC' }}>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#88451D' }}>
                            <b>Acima de 6.000</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#88451D' }}>
                            <b>+R$ 40,00 por faixa de 1.000</b>
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ color: '#F0A11A' }}>
                            <b>R$ 0,40 por nota</b>
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box style={{ display: 'flex', gap: 10, padding: 20, borderRadius: 10, borderLeft: '3px solid #0D1F3C', backgroundColor: '#EFF6FF', marginTop: 10, marginBottom: 10 }}>
                  <Info color='primary' />
                  <Typography variant='body2' style={{ color: '#1E40AF' }}>
                    A partir de 6.001 notas, a cada faixa adicional de 1.000 notas o valor máximo mensal acresce R$ 40,00 e a tarifa de excedente permanece em R$ 0,40 por nota.
                  </Typography>
                </Box>
              </StepCard>
            </Grid>
            <Grid item xs={12}>
              <StepCard
                icon={<LocalAtm color='primary' />}
                title='3. Regras de Cobrança'
              >
                <Typography variant='body2' color='primary'>
                  <b>3.1 — Apuração Mensal</b>
                  <br />
                  A quantidade de notas emitidas será apurada mensalmente, com base no total acumulado no período de faturamento. O enquadramento na faixa correspondente ocorrerá automaticamente conforme o volume apurado, não sendo necessária a escolha prévia, contratação específica ou solicitação de migração entre faixas.
                  <br />
                  <br />
                  <b>3.2 — Cálculo Progressivo</b>
                  <br />
                  Ao ultrapassar o limite de uma faixa, o valor será calculado de maneira progressiva, considerando: (i) o valor máximo mensal da faixa imediatamente anterior; (ii) a quantidade de notas emitidas acima do limite inferior da nova faixa; e (iii) a tarifa por nota aplicável à nova faixa. O valor calculado ficará limitado ao valor máximo mensal da faixa em que o CONTRATANTE estiver enquadrado.
                  <br />
                  <br />
                  A fórmula aplicada é: valor mensal = valor máximo da faixa anterior + quantidade excedente x tarifa por nota da faixa atual, limitado ao teto mensal da faixa atual. O valor máximo de uma faixa não é cobrado automaticamente ao ultrapassar o limite da faixa anterior — a cobrança cresce progressivamente até alcançar o teto.
                </Typography>
                <Box style={{ padding: 20, borderRadius: 10, border: '1px solid #E0E0E0', backgroundColor: '#F5F5F5', marginTop: 10, marginBottom: 10 }}>
                  <Typography variant='body2' color='primary'>
                    <b>Exemplo prático:</b>
                  </Typography>
                  <br />
                  <Typography variant='body2' color='primary'>
                    Na emissão de 1.030 notas no mês, o valor cobrado será o teto da faixa anterior (R$ 49,00) acrescido de 30 notas excedentes a R$ 0,80 cada, totalizando R$ 73,00. A cobrança só atingirá o teto de R$ 89,00 quando forem emitidas 1.050 notas ou mais.
                  </Typography>
                </Box>
                <Typography variant='body2' color='primary'>
                  <b>3.3 — Faixa Gratuita</b>
                  <br />
                  A faixa de 0 a 500 notas mensais é disponibilizada sem custo ao CONTRATANTE. O excedente além de 500 notas será cobrado à tarifa de R$ 0,98 por nota emitida, limitado ao teto mensal de R$ 49,00 da faixa seguinte.
                  <br />
                  <br />
                  <b>3.4 — Forma de Cobrança</b>
                  <br />
                  Os valores apurados mensalmente serão incluídos na fatura do mês subsequente à apuração, seguindo as mesmas condições de vencimento e pagamento previstas no Termo de Uso principal da plataforma.
                  <br />
                  <br />
                  <b>3.5 — Faixas Acima de 6.000 Notas</b>
                  <br />
                  A partir de 6.001 notas, serão aplicadas faixas adicionais de 1.000 notas, criadas dinamicamente. Para cada nova faixa, o valor máximo mensal é acrescido em R$ 40,00, mantendo-se a tarifa progressiva de R$ 0,40 por nota. Exemplo: na emissão de 6.001 notas, o valor será de R$ 269,40 (teto da faixa anterior de R$ 269,00 acrescido de uma nota excedente a R$ 0,40). Ao atingir 6.100 notas, será alcançado o teto da faixa de 6.001 a 7.000 notas, no valor de R$ 309,00.
                </Typography>
              </StepCard>
            </Grid>
            <Grid item xs={12}>
              <StepCard
                icon={<img src={NfsePremiumIcon} width={20} height={20} />}
                title='4. Funcionalidade Integrante do Plano Premium'
              >
                <Typography variant='body2' color='primary'>
                  A emissão de notas fiscais é uma funcionalidade integrante do <b>Plano Premium</b> da Jump Tecnologia, que também poderá incluir outras funcionalidades especiais, adicionais ou avançadas disponibilizadas pela CONTRATADA.
                  <br />
                  <br />
                  A contratação do Plano Premium possui valor adicional de:
                  <br />
                  <ul>
                    <li>até <b>R$ 30,00 por mês</b>, quando a contratação ocorrer na modalidade mensal;</li>
                    <li>até <b>R$ 20,00 por mês</b>, quando a contratação ocorrer na modalidade anual.</li>
                  </ul>
                  Os valores referentes ao Plano Premium são independentes da cobrança variável calculada conforme a quantidade de notas fiscais emitidas. Dessa forma, o valor mensal relacionado à emissão de notas fiscais poderá ser composto por: (i) valor adicional correspondente ao Plano Premium, conforme a modalidade de contratação; e (ii) valor variável calculado de acordo com a quantidade de notas fiscais emitidas e as faixas previstas na tabela de preços.
                  <br />
                  <br />
                  O valor do Plano Premium <b>não substitui, não absorve e não elimina</b> a cobrança por faixa de emissão de notas fiscais, que seguirá exclusivamente as regras de enquadramento automático, cálculo progressivo, excedente e teto máximo mensal previstas neste Termo. A CONTRATADA poderá disponibilizar outras funcionalidades dentro do Plano Premium, observadas as condições comerciais vigentes.
                </Typography>
              </StepCard>
            </Grid>
            <Grid item xs={12}>
              <StepCard
                icon={<Warning color='primary' />}
                title='5. Responsabilidade pela Emissão'
              >
                <Box style={{ padding: 20, borderRadius: 10, borderLeft: '3px solid #DC2626', backgroundColor: '#FEE2E2', marginTop: 10, marginBottom: 10 }}>
                  <Typography variant='body2' color='error'>
                    A responsabilidade total e exclusiva pela emissão correta das notas fiscais, incluindo prazo, conteúdo, tributos, códigos fiscais e obrigações acessórias, é do CONTRATANTE. A Jump Tecnologia disponibiliza a funcionalidade como facilitador operacional, não se responsabilizando por erros, multas, autuações fiscais ou penalidades decorrentes do uso da ferramenta.
                  </Typography>
                </Box>
                <Typography variant='body2' color='primary'>
                  Compete ao CONTRATANTE verificar o correto preenchimento das informações fiscais, manter os dados cadastrais atualizados junto à prefeitura ou órgão competente e acompanhar os prazos de obrigação fiscal aplicáveis à sua atividade.
                </Typography>
              </StepCard>
            </Grid>
            <Grid item xs={12}>
              <StepCard
                icon={<CalendarToday color='primary' />}
                title='6. Vigência e Aceite'
              >
                <Typography variant='body2' color='primary'>
                  Este Termo entra em vigor em 1º de agosto de 2026 e aplica-se a todos os CONTRATANTES que utilizem a funcionalidade de emissão de notas fiscais nas plataformas Jump Park e Jump Car a partir dessa data.
                  <br />
                  <br />
                  O uso da funcionalidade de emissão de notas fiscais após a data de vigência será considerado aceite tácito, integral e vinculante das condições estabelecidas neste Termo.
                  <br />
                  <br />
                  Caso o CONTRATANTE não concorde com as condições aqui estabelecidas, deverá interromper o uso da funcionalidade antes de 1º de agosto de 2026 e comunicar formalmente a Jump Tecnologia por seus canais oficiais.
                </Typography>
                {(isTermsAccepted && isUserAdmin) ? (
                  <Box style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 20, borderRadius: 10, border: '1px solid #E0E0E0', backgroundColor: '#F5F5F5', marginTop: 10, marginBottom: 10 }}>
                    <Typography variant='h6' color='primary'>
                      <b>Usuários que aceitaram os termos</b>
                    </Typography>
                    <Divider />
                    {sortedUniqueTermsOfUseUsers?.map(user => {
                      return(
                        <Typography variant='body1' color='textSecondary'>
                          {user?.name} - {moment(user?.acceptanceDateTime, 'YYYY-MM-DD HH:mm:ss').format('LLL')}
                        </Typography>
                      )
                    })}
                  </Box>
                ) : (
                  <Box
                    style={{ display: 'flex', padding: 20, borderRadius: 10, border: '1px solid #E0E0E0', backgroundColor: '#F5F5F5', marginTop: 10, marginBottom: 10, cursor: 'pointer' }}
                    onClick={() => setIsNfTermsChecked(!isNfTermsChecked)}
                  >
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name='acceptNfTermsOfUse'
                            type='checkbox'
                            disabled={isTermsAccepted}
                            checked={isNfTermsChecked || isTermsAccepted}
                            onChange={event => setIsNfTermsChecked(event.target.checked)}
                          />
                        }
                      />
                    </Box>
                    <Box>
                      <Typography variant='body2' color='primary'>
                        <b>Declaro que li, compreendi e aceito integralmente os termos e condições estabelecidos neste instrumento, reconhecendo sua validade jurídica.</b>
                      </Typography>
                      <br />
                      <Typography variant='body2' color='textSecondary'>
                        Jump Tecnologia de Informação LTDA · CNPJ 18.181.367/0001-14
                      </Typography>
                    </Box>
                  </Box>
                )}
              </StepCard>
            </Grid>
          </Grid>
        </DialogContent>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: 20, backgroundColor: '#FFFFFF' }}>
          {!isTermsAccepted && (
            <Button
              loading={isTermsOfUseLoading}
              disabled={!isNfTermsChecked}
              color="success"
              onClick={handleConfirmTermsOfUse}
              startIcon={<CheckCircle />}
            >
              Aceitar Termo
            </Button>
          )}
        </Box>
      </Loader>
    </Dialog>
  );
}